import * as React from 'react';
import { Row, Col, Table } from 'reactstrap';
import { RagBadge } from '../Components';
import { parseBoolean, isNullOrWhiteSpace } from '../../../Services/Util';
import { IPackIdentifier } from '../../../Types';

interface ISinglePackResponseProps {
    result: any;
    resources: any;
    showHelpLink: any;
    packIdentifier: IPackIdentifier;
}

export const SinglePackResponse = (props: ISinglePackResponseProps) => {
    return (
        <div>
            <Row>
                <Col xs="auto">
                    <RagBadge result={props.result} />
                </Col>
                <Col className="fv-c">
                    <span color="secondary" className="rag-span" style={{ whiteSpace: "pre-line" }}>
                        {
                            (props.result.packInfo?.Information ||
                            props.result.packInfo?.Warning +                             
                            (props.result.packInfo?.Uprc ? "\n" + props.resources.UPRC + ": " + props.result.packInfo?.Uprc : "") +
                            (props.result.packInfo?.AmsLink ? "\n" + props.resources.AmsLink+ ": " + props.result.packInfo?.AmsLink : "")+
                            (props.result.packInfo?.AlertCode ? "\n" + props.resources.AlertCode + ": " + props.result.packInfo?.AlertCode : "") ) +
                            (props.result.packInfo?.Nhrn ? "\n" + props.resources.Nhrn+ ": " + props.result.packInfo?.Nhrn : "")+
                            (props.result.packInfo?.OperationCode ? "\n" + props.resources.OperationCode + ": " + props.result.packInfo?.OperationCode : "")
                        }
                    </span>
                </Col>
            </Row>
            {props.result.packInfo?.ProductInfo && 
            <div>
                <Table>
                    <thead>
                        <tr>
                            <th colSpan={2}>{props.resources.ProductInfo}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.result.packInfo?.ProductInfo?.batchid &&
                            <tr>
                                <td>{props.resources.BatchID}</td>
                                <td><span className="text-muted">{props.result.packInfo?.ProductInfo.batchid}</span></td>
                            </tr>
                        }
                        {props.result.packInfo?.ProductInfo?.productName &&
                            <tr>
                                <td>{props.resources.ProductName}</td>
                                <td><span className="text-muted">{props.result.packInfo?.ProductInfo?.productName ?? props.result?.packInfo?.ProductName}</span></td>
                            </tr>
                        }
                        {props.result.packInfo?.ProductInfo?.expiryDate &&
                            <tr>
                                <td>{props.resources.ExpiryDate}</td>
                                <td><span className="text-muted">{props.result.packInfo?.ProductInfo?.expiryDate}</span></td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>
            }
            <Row className="mt-2">
                <Col>
                    {(parseBoolean(props.showHelpLink) && !isNullOrWhiteSpace(props.result.packInfo.OperationCode)) ? <a href={`https://www.imvo.ie/op-code?OpCode=${props.result.packInfo.OperationCode}&PC=${props.packIdentifier.productCode}&SN=${props.packIdentifier.serialNumber}&BN=${props.packIdentifier.batchIdentifier}&EXP=${props.packIdentifier.expiry}&CS=${props.packIdentifier.scheme}`} target="_blank">Learn More</a> : ""}
                </Col>
            </Row>
        </div>
    );
};